import { DeliveriesStore, Item } from "./DeliveriesStore";
import "./DeliveryDetailsElement.less";

export class DeliveryDetailsElement extends HTMLElement { 
    static tag = "delivery-details";
    private _button: HTMLButtonElement;

    connectedCallback() { 
        this.innerHTML = this.view();
        this._button = this.querySelector("button");
        this._button.addEventListener("click", this.onClick);
    }

    private onClick = async () => { 
        if (this.toggleAttribute("open")) { 
            this.toggleAttribute("loading", true);
            try {
                const items = await DeliveriesStore.instance.getDetails(this.getDeliveryIdentifier());

                // remove exiting items
                this.querySelectorAll(".item").forEach(item => item.remove());

                this.insertAdjacentHTML("beforeend", this.itemsView(items));
            } finally { 
                this.toggleAttribute("loading", false);
            }
        }
    }

    private getDeliveryType() : "Invoice" | "Return" { 
        if (this.getAttribute("delivery-type") === "Invoice")
            return "Invoice";
        else if (this.getAttribute("delivery-type") === "Return")
            return "Return";
        else
            throw new Error(`Invalid delivery type: ${this.getAttribute("delivery-type")}`);
    }

    private getDeliveryIdentifier() { 
        return {
            type: this.getDeliveryType(),
            invoiceNo: this.getAttribute("invoice-no"),
            orderNo: this.getAttribute("order-id"),
        };
    }

    private itemView = (item: Item) => `
        <div class="item">    
            <div class=quantity>
                ${item.quantity}
            </div>
            <div class=item-no>
                ${item.itemNo}
            </div>
            <div class=description>
                ${item.text1} ${item.text2}
            </div> 
        </div>
    `;

    private itemsView = (items: Item[]) => `
        ${items.map(item => this.itemView(item)).join("")}
    `;

    private view = () => `
        <div class="line-form">
            <label>Items</label>
            <div>
                <button class=icon type=button>${require("./Images/up-arrow.svg")}</button>
                <div class=loader>${require("./Images/refresh.svg")}</div>
            </div>
        </div>
    `;
}

customElements.define(DeliveryDetailsElement.tag, DeliveryDetailsElement);